import { render, staticRenderFns } from "./LimitlessButtonDropdown.vue?vue&type=template&id=89b38896&scoped=true&"
import script from "./LimitlessButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./LimitlessButtonDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LimitlessButtonDropdown.vue?vue&type=style&index=0&id=89b38896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b38896",
  null
  
)

export default component.exports